"use client";

import * as React from "react";
import { cn } from "../../lib/utils";
import { SEARCH_TAB_STYLES } from "./constants";
import type { ISearchTabProps } from "./types";

export const SearchTab = React.forwardRef<HTMLButtonElement, ISearchTabProps>(
  (
    {
      isActive,
      isTransitioning = false,
      label,
      icon,
      onClick,
      onRef,
      onIconRef,
      testId,
      className,
      role,
      "aria-selected": ariaSelected,
    },
    ref
  ) => {
    const handleRef = (el: HTMLButtonElement | null) => {
      onRef?.(el);
      if (typeof ref === "function") {
        ref(el);
      } else if (ref) {
        ref.current = el;
      }
    };

    return (
      <button
        type="button"
        ref={handleRef}
        onClick={onClick}
        data-testid={testId}
        role={role}
        aria-selected={ariaSelected}
        className={cn(SEARCH_TAB_STYLES.button, className)}
      >
        <div
          ref={onIconRef}
          className={cn(
            SEARCH_TAB_STYLES.iconWrapper,
            isActive && !isTransitioning && SEARCH_TAB_STYLES.iconWrapperActive
          )}
        >
          {icon}
        </div>
        <span className={SEARCH_TAB_STYLES.label}>{label}</span>
      </button>
    );
  }
);

SearchTab.displayName = "SearchTab";
